var React = require('react');

function Shadow (props) {
    return React.createElement("svg",props,React.createElement("ellipse",{"cx":"449","cy":"160.5","fill":"#9AA84A","fillRule":"evenodd","opacity":".506","rx":"424","ry":"22.5","transform":"translate(0 -132)"}));
}

Shadow.defaultProps = {"width":"878","height":"54","viewBox":"0 0 878 54"};

module.exports = Shadow;

Shadow.default = Shadow;
